var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"weetContainer"},[_c('iframe',{staticClass:"weetPlayer",attrs:{"id":"weetPlayer","type":"text/html","src":_vm.url,"allowtransparency":"true","allowfullscreen":"","frameborder":"0","height":"100%"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }